<template>
  <div class="wrapper">
    <!-- <div class="content">
      <h1>Nueva llave</h1>
    </div>-->
    <section class="content alineacion">
      <form @submit="addUser($event)">
        <div class="form-row">
          <div class="form-group col-md-12" v-if="!isError">
            <label for="inputEmail4">{{$t('Email')}}</label>
            <input 
              type="email"
              v-model="newKey.email"
              class="form-control"
              id="inputEmail4"
              placeholder="Email"
              v-on:blur="checkIsUserRegistered()"
            />
            <small
              v-if="isError"
              class="error"
            >{{$t('keyNotRegisteredEmail')}}</small>
            <small v-if="isChecked" class="correct">{{$t('keyRegisteredEmail')}}</small>
          </div>
          <div class="form-group col-md-8" v-else>
            <label for="inputEmail4">{{$t('Email')}}</label>
            <input 
              type="email"
              v-model="newKey.email"
              class="form-control"
              id="inputEmail4"
              placeholder="Email"
              v-on:blur="checkIsUserRegistered()"
            />
            <small
              v-if="isError"
              class="error"
            >{{$t('keyNotRegisteredEmail')}}</small>
            <small v-if="isChecked" class="correct">{{$t('keyRegisteredEmail')}}</small>
          </div>
          <div class="form-group col-md-4">
            <p><label v-if="isError" for="inputLangUser">{{$t('addKeyLanguages')}}</label></p>
            <b-dropdown v-if="isError" :text="language_user.toUpperCase()">
              <b-dropdown-item  class="button-flag"  v-for="entry in languages_user" :key="entry.title" @click="changeLocaleUser(entry.language)"> 
                <div v-if="language_user!=entry.language"><flag :iso="entry.flag" v-bind:squared=false /> {{entry.language.toUpperCase()}}</div>
              </b-dropdown-item>
              <b-dropdown-item @click="changeLocaleUser('all')">{{$t('addKeyLanguage')}}</b-dropdown-item>
            </b-dropdown>
          </div>         
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <!-- <HotelDatePicker format="DD/MM/YYYY" :startDate="getDateToStart()" [v-model]="newKey.notBefore" ></HotelDatePicker> -->
            <label for="inputAddress">{{$t('keyInitDate')}}</label>
            <input
              type="datetime-local"
              v-model="newKey.notBefore"
              class="form-control"
              id="inputAddress"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="inputAddress2">{{$t('keyFinishDate')}}</label>
            <input
              type="datetime-local"
              v-model="newKey.notAfter"
              class="form-control"
              id="inputAddress2"
              required
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group offset-md-3 col-md-6">
            <label for="inputState">{{$t('keySelectLock')}}</label>
            <select id="inputState" class="form-control" v-model="room">
              <option disabled value>{{$t('keySelection')}}</option>
              <option v-for=" lock in datosLocker" :key="lock.lastUpdate">{{lock.brief_desc}}</option>
            </select>
          </div>
        </div>
          <button type="submit" class="btn btn-primary" v-if="newKey.email" >{{$t('keyAdd')}}</button>
          <!-- <button type="submit" class="btn btn-primary">Give Access</button> -->
      </form>
    </section>
  </div>
</template>

<script>
/* import btoa from "btoa"; */
import _ from "lodash";
import HotelDatePicker from "vue-hotel-datepicker";
import i18n from '@/plugins/i18n';

export default {
  data() {
    return {
      pasarelaData: {},
      rooms: [],
      room: "",
      datosLocker: [],
      pagination: [],
      newKey: {
        email: "",
        notBefore: "",
        notAfter: "",
        deviceId: ""
      },
      timeNow: "",
      isChecked: false,
      isError: false,
      validData: true,
      language:localStorage.getItem('language'),
      language_user:"",
      languages_user: [{ 
                    flag: 'gb', 
                    language: 'en', 
                    title: 'English' 
                  },
                  { flag: 'es', 
                    language: 'es', 
                    title: 'Español' },
                  { flag: 'de',
                    language: 'de',
                    title: 'Deutsch'}]
    };
  },
  methods: {
    checkIsUserRegistered() {
      console.log("checkUserRegistered");
      var login = JSON.parse(localStorage.getItem("session"));
      this.axios
        .post(
          "https://lightkey.es:3000/lightkey/api/users/email",
          // "https://lightkey.es:3000/lightkey/api/users/email",
          { email: this.newKey.email },
          {
            headers: { authorization: login.session }
          }
        )
        .then(response => {
          if (response.data.email) {
            //Si está
            this.isChecked = true;
            this.isError = false;
            //this.newKey.email = response.data.email;
            console.log(this.newKey);
          } else {
            this.isChecked = false;
            this.isError = true;
          }
        })
        .catch(err => console.log(err));
    },

    randomPassword() {
      var chars =
        "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 10; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      return pass;
    },

    lockersAvailable() {
      // console.log("Entra por aquí");
      var login = JSON.parse(localStorage.getItem("session"));

      this.axios
        .get("https://lightkey.es:3000/lightkey/api/locks", {
          headers: { authorization: login.session }
        })
        .then(response => {
          // console.log("respuesta de locks disponibles", response.data);
          response.data.forEach(dato => {
            this.datosLocker.push(dato);
          });
          console.log(this.datosLocker);

          /* 
          console.log("Array rooms", this.datosLocker);
          this.rooms = this.datosLocker.map(room => room.brief_desc);
          console.log("Rooms", this.rooms); */
        })
        .catch(err => {
          console.error("Ocurrio un error cargando usuarios", err);
          this.$router.replace("/");
        });
    },

    addUser(event) {
      event.preventDefault();
      // console.log("Add user", this.room);
      // console.log("Estos son los datos", this.datosLocker);

      this.newKey.deviceId = this.datosLocker.find(
        lock => lock.brief_desc == this.room
      ).deviceId;

      var login = JSON.parse(localStorage.getItem("session"));

      console.log("Hay que revisar como se envia el objeto --> ", this.newKey);
      console.log({ login });

      //Si el correo no se encuentra dentro de la base de datos. Creamos el usuario
      if (this.isError) {
        console.log("Creamos un usuario del tipo que quiera.");

        const passGenerated = this.randomPassword();

        const addNewUser = {
          firstname: "Usuario",
          lastname: "Nuevo",
          enabled: true,
          email: this.newKey.email,
          password: passGenerated,
          phone: "",
          role: "ROLE_USER"
        };

        // console.log({ addNewUser });

        this.axios
          .post("https://lightkey.es:3000/lightkey/api/users/", addNewUser, {
            headers: { authorization: login.session }
          })
          .then(response => {
            // console.log("Lo he añadido");
            // console.log(response.data);
            switch(i18n.locale){
              case "en":
                this.$toastr.s(i18n.messages.en.userCreated);
                break;
              case "es":
                this.$toastr.s(i18n.messages.es.userCreated);
                break;
              case "de":
                this.$toastr.s(i18n.messages.de.userCreated);
                break;  
            }
            // this.axios
            //       .post("https://lightkey.es:3000/lightkey/api/users/send/email", {
            //         email: addNewUser.email,
            //         passRandom: addNewUser.password
            //       })
            //       .then(response => {
            //          this.$toastr.s("Se ha enviado el correo.");
            //       })
            //       .catch(err => console.log("Error por el mail"));
            console.log("Creamos llave");
            this.axios
              .post(
                "https://lightkey.es:3000/lightkey/api/keys/",
                this.newKey,
                {
                  headers: { authorization: login.session }
                }
              )
              .then(response => {
                 console.log("Se ha respondido correctamente");
                 console.log(response.data);
                  console.log("creamos usuario");
                this.axios
                  .post("https://lightkey.es:3000/lightkey/api/users/send/email", {
                  // .post("https://lightkey.es:3000/lightkey/api/users/send/email", {
                    email: addNewUser.email,
                    passRandom: addNewUser.password,
                    language:this.language_user
                  })
                  .then(response => {
                    switch(i18n.locale){
                      case "en":
                        this.$toastr.s(i18n.messages.en.userSendEmail);
                        break;
                      case "es":
                        this.$toastr.s(i18n.messages.es.userSendEmail);
                        break;
                      case "de":
                        this.$toastr.s(i18n.messages.de.userSendEmail);
                        break;  
                    }
                  })
                  .catch(err => console.log("Error por el mail"));

                switch(i18n.locale){
                  case "en":
                    this.$toastr.s(i18n.messages.en.userCreated);
                    break;
                  case "es":
                    this.$toastr.s(i18n.messages.es.userCreated);
                    break;
                  case "de":
                    this.$toastr.s(i18n.messages.de.userCreated);
                    break;  
                }
                this.$router.replace("/dashboard/view-users");
              })
              .catch(err => {
                console.log(err);
                /* this.$router.replace("/"); */
              });
          })
          .catch(err => {
            console.log(err);
            /*  this.$router.replace("/"); */
          });
      } else {
        console.log("El correo esta en la bd");
        this.axios
          .post("https://lightkey.es:3000/lightkey/api/keys", this.newKey, {
            headers: { authorization: login.session }
          })
          .then(response => {
            // console.log("Se ha respondido correctamente");
            // console.log(response.data);
              switch(i18n.locale){
                case "en":
                  this.$toastr.s(i18n.messages.en.userCreated);
                  break;
                case "es":
                  this.$toastr.s(i18n.messages.es.userCreated);
                  break;
                case "de":
                  this.$toastr.s(i18n.messages.de.userCreated);
                  break;  
              }
            this.$router.replace("/dashboard/view-users");
          })
          .catch(err => {
            console.log(err);
            this.$router.replace("/");
          });
      }

      //Añadir el usuario

      //Cambiar por el codigo obtenido anteriormente
    },
    habIsAvailable(notBefore, notAfter) {
      //Devuelve true o false si está disponible o no.
      return true;
    },
    dateRightNow() {
      //aaaa-mm-dd
      var fechaActual = new Date();
      this.timeNow = `${fechaActual.getFullYear()}-${fechaActual.getMonth()}-${fechaActual.getDate()}`;
    },
    gettingDevicesId(room) {
      return this.datosLocker.find(lock => lock.brief_desc == room).devicesId;
    },
    getDateToStart() {
      const date = new Date();
      const dateSelected = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      // console.log({ dateSelected });
      return dateSelected;
    },
    setLanguage(){
      if(localStorage.getItem('language')){
        console.log(localStorage.getItem('language'));
        i18n.locale = localStorage.getItem('language');
        this.language_user=localStorage.getItem('language');
      }else{
        console.log("No hay lenaguaje");
      }
    },
    changeLocaleUser(locale) {        
      this.language_user=locale;
      console.log(this.language_user);
    } 
  },
  created() {
    this.lockersAvailable();
    this.dateRightNow();
    this.setLanguage();
  },
  watch: {},
  computed: {
    validation() {}
  },
  components: {
    HotelDatePicker
  }
};
</script>


<style >

.wrapper {
  display: grid;
  grid-template-columns: 1fr 1100px 1fr;
}

.content {
  grid-column: 2/3;
}

.error {
  color: red;
}

.correct {
  color: green;
}
h1 {
  margin-top: 20px;
}

.alineacion {
  margin-top: 90px;
}

.btn {
  background-color: #5cb85c;
  color: white;
  border: 1px solid #4cae4c;
}

@media (max-width: 1160px) {
  .wrapper {
    display: grid;
    grid-template-columns: 1fr 99% 1fr;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/children/Key.vue